console.log('gift-progress simple loaded');

(function () {
  const widgetSelector = '[data-gift-progress]';
  const initializedAttr = 'data-gift-initialized';

  const TIERS = [
    {
      min: 45000,
      reward: 'Decant 2ml'
    },
    {
      min: 60000,
      reward: 'Decant 5ml'
    },
    {
      min: 90000,
      reward: 'Body Spray'
    }
  ];

  async function fetchCart() {
    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    });

    if (!response.ok) {
      throw new Error('No se pudo cargar el carrito');
    }

    return await response.json();
  }

  function formatMoney(value) {
    return '₡' + new Intl.NumberFormat('es-CR').format(Math.round(value));
  }

  function getNextTier(subtotal) {
    return TIERS.find((tier) => subtotal < tier.min) || null;
  }

  function getCurrentUnlockedTier(subtotal) {
    let current = null;
    TIERS.forEach((tier) => {
      if (subtotal >= tier.min) current = tier;
    });
    return current;
  }

  async function renderWidget(widget) {
    const fill = widget.querySelector('[data-gift-fill]');
    const message = widget.querySelector('[data-gift-message]');
    const tierEls = widget.querySelectorAll('[data-tier]');

    if (!fill || !message) return;

    const cart = await fetchCart();
    const subtotal = (cart.total_price || 0) / 100;

    const maxThreshold = 90000;
    const progress = Math.min((subtotal / maxThreshold) * 100, 100);
    fill.setAttribute(
      'style',
      `width:${progress}%; background:#111; display:block; position:absolute; left:0; top:0; bottom:0; opacity:1; visibility:visible; z-index:5; border-radius:999px;`
    );

    const currentUnlockedTier = getCurrentUnlockedTier(subtotal);
    const nextTier = getNextTier(subtotal);

    if (!currentUnlockedTier) {
      const diff = TIERS[0].min - subtotal;
      message.textContent = `Te faltan ${formatMoney(diff)} para desbloquear tu primer regalo.`;
    } else if (nextTier) {
      const diff = nextTier.min - subtotal;
      message.textContent = `Ya desbloqueaste 🎁 ${currentUnlockedTier.reward}. Te faltan ${formatMoney(diff)} para el siguiente regalo.`;
    } else {
      message.textContent = `Ya desbloqueaste el regalo máximo: 🎁 ${currentUnlockedTier.reward}.`;
    }

    tierEls.forEach((el) => {
      const tierValue = Number(el.getAttribute('data-tier'));
      el.classList.remove('is-active', 'is-unlocked');

      if (subtotal >= tierValue) {
        el.classList.add('is-unlocked');
      }

      if (nextTier && tierValue === nextTier.min) {
        el.classList.add('is-active');
      }

      if (!nextTier && tierValue === 90000) {
        el.classList.add('is-active');
      }
    });
  }

async function initWidgets() {
  const widgets = document.querySelectorAll(`${widgetSelector}:not([${initializedAttr}])`);
  if (!widgets.length) return;

  for (const widget of widgets) {
    try {
      await renderWidget(widget);
      widget.setAttribute(initializedAttr, 'true');
    } catch (e) {
      console.error('[gift-progress]', e);
    }
  }

  await syncAutoGift();
}

  function isGiftItem(item) {
    return item.properties && item.properties._auto_gift === 'true';
  }

  function getSubtotalWithoutGift(cart) {
    return cart.items.reduce((sum, item) => {
      if (isGiftItem(item)) return sum;
      return sum + item.final_line_price;
    }, 0) / 100;
  }

  function findAutoGiftLine(cart) {
    const index = cart.items.findIndex((item) => isGiftItem(item));
    if (index === -1) return null;

    return {
      ...cart.items[index],
      line: index + 1
    };
  }

  function getTargetGiftTier(subtotal, tiers) {
    let current = null;
    tiers.forEach((tier) => {
      if (subtotal >= tier.min) current = tier;
    });
    return current;
  }

  async function fetchCart() {
    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    });

    if (!response.ok) {
      throw new Error('No se pudo cargar el carrito');
    }

    return await response.json();
  }

  async function addAutoGift(variantId, giftKey) {
  console.log('[auto gift add] start', { variantId, giftKey });

  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    credentials: 'same-origin',
    body: JSON.stringify({
      items: [
        {
          id: Number(variantId),
          quantity: 1,
          properties: {
            _auto_gift: 'true',
            _gift_key: giftKey
          }
        }
      ]
    })
  });

  const text = await response.text();

    if (!response.ok) {
      console.error('[auto gift add error]', response.status, text);
      throw new Error(text || 'No se pudo agregar el regalo');
    }

    try {
      return JSON.parse(text);
    } catch (e) {
      return text;
    }
  }

  async function removeCartLine(line) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        line: Number(line),
        quantity: 0
      })
    });

    if (!response.ok) {
      throw new Error('No se pudo quitar el regalo');
    }

    return await response.json();
  }

 let autoGiftSyncInProgress = false;

async function syncAutoGift() {
  if (autoGiftSyncInProgress) return;
  autoGiftSyncInProgress = true;

  try {
    const widget = document.querySelector('[data-auto-gift-config]');
    console.log('[auto gift] widget:', widget);

    if (!widget) return;

    const rawConfig = widget.getAttribute('data-auto-gift-config');
    console.log('[auto gift] raw config:', rawConfig);

    if (!rawConfig) return;

    const config = JSON.parse(rawConfig);
    const tiers = config.tiers || [];
    console.log('[auto gift] tiers:', tiers);

    if (!tiers.length) return;

    const cart = await fetchCart();
    console.log('[auto gift] cart:', cart);

    const subtotal = getSubtotalWithoutGift(cart);
    console.log('[auto gift] subtotal:', subtotal);

    const targetTier = getTargetGiftTier(subtotal, tiers);
    const currentGift = findAutoGiftLine(cart);

    console.log('[auto gift] targetTier:', targetTier);
    console.log('[auto gift] currentGift:', currentGift);

    if (!targetTier && currentGift) {
      console.log('[auto gift] removing old gift');
      await removeCartLine(currentGift.line);
      window.location.reload();
      return;
    }

    if (!targetTier && !currentGift) {
      console.log('[auto gift] no tier, no gift');
      return;
    }

    if (targetTier && !currentGift) {
      console.log('[auto gift] adding gift:', targetTier.variantId);
      await addAutoGift(targetTier.variantId, targetTier.key);
      window.location.reload();
      return;
    }

    if (targetTier && currentGift) {
      const currentVariantId = Number(currentGift.variant_id);
      const targetVariantId = Number(targetTier.variantId);
      const currentGiftKey = currentGift.properties && currentGift.properties._gift_key;

      if (currentVariantId !== targetVariantId || currentGiftKey !== targetTier.key) {
        console.log('[auto gift] replacing gift');
        await removeCartLine(currentGift.line);
        await addAutoGift(targetVariantId, targetTier.key);
        window.location.reload();
        return;
      }

      console.log('[auto gift] correct gift already in cart');
    }
  } catch (e) {
    console.error('[auto gift sync error]', e);
  } finally {
    autoGiftSyncInProgress = false;
  }
}

  document.addEventListener('DOMContentLoaded', initWidgets);

  const observer = new MutationObserver(() => {
    document.querySelectorAll(widgetSelector).forEach((widget) => {
      widget.removeAttribute(initializedAttr);
    });
    initWidgets();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();